import { ADD_AGENCY_PUBLISHER_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import addAgencyPublisher from 'root/src/client/logic/brandSettings/thunks/addAgencyPublisher'

export default {
	[ADD_AGENCY_PUBLISHER_FORM_MODULE_ID]: [
		{
			action: addAgencyPublisher,
			// onSuccess: dropUploadKeysOnSuccess, // TODO
		},
	],
}
